var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",staticStyle:{"padding":"3rem"}},[_c('b-spinner',{staticStyle:{"width":"5rem","height":"5rem"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }